import React from 'react';
import { Box } from '@mui/material';

const JerseyDisplay = ({ 
  team, 
  size = 32, 
  sx = {},
  variant = 'box' // 'box', 'circle', or 'jersey'
}) => {
  const isWhiteColor = (color) => {
    if (!color) return false;
    const normalizedColor = color.toLowerCase().trim();
    return normalizedColor === '#ffffff' || 
           normalizedColor === '#fff' || 
           normalizedColor === 'white' || 
           normalizedColor === 'rgb(255,255,255)' ||
           normalizedColor === 'rgb(255, 255, 255)';
  };

  const jerseyColor = team.jerseyColorHex || team.primaryColor;
  const jerseyName = team.jerseyColorName || team.primaryColorName;
  
  if (!jerseyColor) return null;

  const isWhite = isWhiteColor(jerseyColor);

  const baseStyles = {
    width: size,
    height: size,
    backgroundColor: jerseyColor,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...sx
  };

  if (variant === 'circle') {
    return (
      <Box
        sx={{
          ...baseStyles,
          borderRadius: '50%',
          border: isWhite ? '2px solid rgba(0,0,0,0.3)' : '2px solid rgba(0,0,0,0.2)',
        }}
        title={jerseyName || 'Team jersey color'}
      />
    );
  }

  if (variant === 'jersey') {
    return (
      <Box
        sx={{
          ...baseStyles,
          borderRadius: '4px',
          border: isWhite ? '2px solid rgba(0,0,0,0.3)' : '2px solid rgba(0,0,0,0.2)',
        }}
        title={jerseyName || 'Team jersey color'}
      >
        {/* Jersey shape indicator */}
        <Box
          sx={{
            width: size * 0.625, // 20px when size is 32
            height: size * 0.75,  // 24px when size is 32
            backgroundColor: jerseyColor,
            borderRadius: '2px 2px 4px 4px',
            border: isWhite ? '1px solid rgba(0,0,0,0.4)' : '1px solid rgba(255,255,255,0.5)',
          }}
        />
      </Box>
    );
  }

  // Default 'box' variant
  return (
    <Box
      sx={{
        ...baseStyles,
        borderRadius: '4px',
        border: isWhite ? '2px solid rgba(0,0,0,0.3)' : '2px solid rgba(0,0,0,0.2)',
      }}
      title={jerseyName || 'Team jersey color'}
    />
  );
};

export default JerseyDisplay;